"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var label_1 = tslib_1.__importDefault(require("../../../util/responsive/apply/label"));
var ApplyResponsiveColumnLabel = /** @class */ (function (_super) {
    tslib_1.__extends(ApplyResponsiveColumnLabel, _super);
    function ApplyResponsiveColumnLabel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ApplyResponsiveColumnLabel.prototype.getType = function () {
        if (this.plot.column.label) {
            if (!this.plot.column.label.position || this.plot.column.label.position === 'top') {
                return 'top';
            }
        }
        return 'inner';
    };
    return ApplyResponsiveColumnLabel;
}(label_1.default));
function responsivePointLabel(layer) {
    var responsiveTheme = layer.getResponsiveTheme();
    var applyResponsiveColumnLabel = new ApplyResponsiveColumnLabel({
        plot: layer,
        responsiveTheme: responsiveTheme,
    });
}
exports.default = responsivePointLabel;
//# sourceMappingURL=label.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2plot/lib/plots/column/apply-responsive/label.js
// module id = 889
// module chunks = 37